import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { tap } from 'rxjs/operators';
import { ToastService } from '../../../../../main/services';
import { Tender } from '../../../../models';
import { TenderContractsService, TenderSuppliersService } from '../../../../services';

@Component({
    selector: 'jft-create-supplier-bunch-file-modal',
    templateUrl: './create-supplier-bunch-file-modal.component.html',
    styleUrls: ['./create-supplier-bunch-file-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateSupplierBunchFileModalComponent implements OnInit {

    public form: UntypedFormGroup;
    public loading: boolean = false;
    public loadingTemplate: boolean = false;

    constructor(
        private toast: ToastService,
        private tender: Tender,
        private service: TenderContractsService,
        private activeModal: NgbActiveModal,
        private supplierService: TenderSuppliersService
    ) {
    }

    public ngOnInit() {
    }

    public getFormGroupErrorClasses(control: AbstractControl): {} {
        return { 'is-invalid': control.invalid && control.touched };
    }

    public showErrorBlock(control: AbstractControl): boolean {
        return control.errors && (control.dirty || control.touched);
    }

    public close() {
        this.activeModal.dismiss();
    }

    public submitSupplier() {
    }

    public downloadTemplate($event: Event) {
        $event.preventDefault();
        $event.stopPropagation();
        if (this.loadingTemplate) {
            return;
        }
        this.loadingTemplate = true;

        this.supplierService.downloadContactsTemplate().subscribe((response: Blob) => {
            const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'JFT - Import Contacts Template.xlsx';
            link.click();
            window.URL.revokeObjectURL(url);
            this.loadingTemplate = false;
        }, () => {
            this.loadingTemplate = false;
        });
    }

    public filesSelected(files: File[]) {
        if (!files.length) {
            return;
        }

        this.loading = true;
        this.supplierService.uploadSuppliers(this.tender, files[0])
            .pipe(tap(() => this.loading = false))
            .subscribe(data => {
                this.toast.success(`${data.details}`);
                this.activeModal.close();
            }, (err) => {
                this.close();
                if (err.error.details) {
                    // Handle both array and string formats for details
                    if (Array.isArray(err.error.details)) {
                        err.error.details.forEach(response => {
                            this.toast.error(response, '');
                        });
                    } else {
                        this.toast.error(err.error.details, '');
                    }
                } else {
                    this.toast.error(err.error);
                }
            });
    }

}
